import axios from "axios";
import { useQuery } from "@tanstack/react-query";
export const fetchProducts = async (filters) => {
  const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/products/filter`, {
    params: filters,
  });   
  return data;
};

